<viewer-memo
  [menu]="memo.is_mine ? myMenu : _singleMode ? undefined : othersMenu"
  [limitHeight]="limitHeight"
  [content]="memo.content"
  [createdAt]="memo.created_at"
  [updatedAt]="memo.updated_at ?? memo.created_at"
  [attr.data-memo-id]="memo.id"
  [isSingleMode]="_isSingleMode"
  [class.active-memo]="_isActive"
  [replyCommentCount]="memo.comment_count"
  [isReplyCommentListOpen]="_isReplyCommentListOpen"
  [isReplyCommentInputOpen]="_isReplyCommentInputOpen"
  (replyCommentOpened)="onReplyCommentOpened()"
>
  <viewer-memo-caution *ngIf="memo.is_blinded">
    <p class="block-tag">신고로 인해 숨김 처리된 메모입니다.</p>
  </viewer-memo-caution>

  <viewer-memo-tag *ngIf="_singleMode && memo.copied_at && memo.is_mine">
    <div class="copy-tag">
      <div>{{ memo.copied_at | date : 'y.MM.dd. HH:mm' }} |&nbsp;</div>
      <div class="source-nickname">{{ memo.source }}</div>
      <div>님의 메모 복사</div>
    </div>
  </viewer-memo-tag>

  <viewer-memo-actions>
    <button
      class="icon-button"
      [class.is-hidden]="memo.is_mine && _singleMode"
      (click)="_onLikeButtonClick()"
    >
      <sui-icon
        name="추천"
        [type]="memo.is_liked ? 'solid' : 'outline'"
      ></sui-icon>
      {{ memo.like_count }}
    </button>
    <button
      class="icon-button"
      [class.is-hidden]="_singleMode"
      (click)="_onCopyToSingleModeButtonClick()"
    >
      <sui-icon name="복사" type="solid"></sui-icon>
      {{ memo.copy_count }}
    </button>
    <!-- 댓글 추가 -->
    <button
      class="icon-button"
      (click)="_replyComment()"
      [class.is-hidden]="_singleMode"
      [disabled]="memo.is_blinded"
    >
      답글달기
    </button>
    <button
      class="text-button"
      (click)="_onSeeDetailsButtonClick()"
      [disabled]="memo.is_blinded"
    >
      {{ _isActive ? '본문 보기 해제' : '본문 보기' }}
    </button>
  </viewer-memo-actions>

  <viewer-memo-author
    *ngIf="!_isSingleMode"
    [avatarImageURL]="memo.author.avatar_image_url"
    [name]="memo.author.nickname"
    [isOnline]="isAuthorOnline"
    (authorClick)="!memo.is_mine && _onAuthorClick()"
    [class.is-clickable]="!memo.is_mine"
    [badgeInfo]="memo.author?.badges?.[0]"
  >
  </viewer-memo-author>

  <viewer-memo-author-single
    *ngIf="_isSingleMode"
    [avatarImageURL]="memo.author.avatar_image_url"
    [name]="memo.author.nickname"
    [isOnline]="isAuthorOnline"
    (authorClick)="!memo.is_mine && _onAuthorClick()"
    [class.is-clickable]="!memo.is_mine"
    [badgeInfo]="memo.author?.badges?.[0]"
  >
  </viewer-memo-author-single>

  <!-- 답글 영역 -->
  <viewer-memo-reply-comment>
    <div class="reply-comment-container" *ngIf="!_isReplyCommentListEmpty">
      <!-- 답글 인풋 박스 -->
      <div
        class="reply-comment-item reply-comment-input-item"
        *ngIf="_isReplyCommentInputOpen"
      >
        <div class="reply-comment-top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="12"
            viewBox="0 0 9 7"
            fill="none"
          >
            <path
              d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
              fill="#999999"
            />
          </svg>

          <viewer-memo-author
            [avatarImageURL]="_currentUser?.avatar_image_url"
            [name]="_currentUser?.nickname ?? ''"
            [badgeInfo]="memo.author?.badges?.[0]"
          >
          </viewer-memo-author>
        </div>
        <div class="reply-comment-input">
          <div
            class="nickname-indent"
            #nicknameElement
            *ngIf="!memo?.is_mine"
            (click)="
              _onCommentAuthorClick({
                bid: _bid,
                id: memo.author.id,
                avatar_image_url: memo.author.avatar_image_url,
                nickname: memo.author.nickname
              })
            "
          >
            &commat;{{ memo.author.nickname }}
          </div>
          <textarea
            rows="1"
            #replyInput
            [(ngModel)]="_replyCommentInputValue"
            (input)="_onReplyInputChange()"
            [style.text-indent]="getNicknameIndent()"
            (scroll)="_onTextareaScroll($event)"
            (keydown.arrowup)="_onTextareaArrowKey($event)"
            (keydown.arrowdown)="_onTextareaArrowKey($event)"
            (keydown.arrowleft)="_onTextareaArrowKey($event)"
            (keydown.arrowright)="_onTextareaArrowKey($event)"
            (keydown)="
              _onReplyTextareaKeyDown($event, !!memo.is_mine, memo.author.id)
            "
          ></textarea>
        </div>
        <div class="reply-comment-input-bottom">
          <span (click)="_onCancelReplyCommentInput()">취소</span>
          <span
            [class.is-active]="_replyCommentInputValue.trim() !== ''"
            (click)="_onSaveReplyCommentInput(!!memo.is_mine, memo.author.id)"
            >저장</span
          >
        </div>
      </div>

      <ng-container *ngIf="_isReplyCommentListOpen">
        <!-- 답글 목록 -->
        <div class="reply-comment-item" *ngFor="let comment of _replyComments">
          <ng-container *ngIf="!comment.isSubReplyChangeOpened">
            <div class="reply-comment-top">
              <svg
                class="reply-comment-top-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="12"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                  fill="#999999"
                />
              </svg>

              <viewer-memo-author
                [avatarImageURL]="comment.author.avatar_image_url"
                [name]="comment.author.nickname"
                (authorClick)="
                  !comment.is_mine && _onCommentAuthorClick(comment.author)
                "
                [class.is-clickable]="!comment.is_mine"
                [badgeInfo]="comment.author?.badges?.[0]"
              >
              </viewer-memo-author>

              <div class="date" *ngIf="!comment.updated_at">
                {{ comment.created_at | date : 'y.MM.dd. HH:mm' }}
              </div>
              <div class="date" *ngIf="comment.updated_at">
                {{ comment.updated_at | date : 'y.MM.dd. HH:mm' }} (수정됨)
              </div>

              <sui-icon
                class="reply-comment-more-button"
                name="더보기 세로형"
                [cdkMenuTriggerFor]="
                  comment.is_mine ? replyMyMenu : replyOthersMenu
                "
                [cdkMenuTriggerData]="{ reply: comment }"
                (click)="$event.preventDefault()"
              ></sui-icon>
            </div>
            <div class="reply-comment-content">
              <span
                *ngIf="comment.mention"
                class="mention-highlight"
                (click)="_onCommentAuthorClick(comment.mention)"
              >
                &commat;{{ comment.mention.nickname }}
              </span>
              <span
                [innerHTML]="
                  (getReplyCommentShortContent(comment.id, comment.content)
                    ? getReplyCommentShortContent(comment.id, comment.content) +
                      '...'
                    : comment.content
                  )
                    | escapeHtml
                    | detectLink
                "
              ></span>
            </div>
            <!-- 자세히보기 간략히 버튼 -->
            <span
              class="show-all-content-button"
              *ngIf="getReplyCommentShortContent(comment.id, comment.content)"
              (click)="onReplyCommentShowAll(comment.id)"
              >자세히 보기
            </span>
            <span
              class="show-all-content-button"
              *ngIf="
                !getReplyCommentShortContent(comment.id, comment.content) &&
                (comment.content.length > 64 ||
                  comment.content.split('\n').length > 3)
              "
              (click)="onReplyCommentShowLess(comment.id, comment.content)"
              >간략히
            </span>

            <div class="reply-comment-bottom">
              <viewer-memo-actions>
                <button
                  class="icon-button"
                  (click)="_onLikeReplyButtonClick(comment.id)"
                >
                  <sui-icon
                    name="추천"
                    [type]="comment.is_liked ? 'solid' : 'outline'"
                  ></sui-icon>
                  {{ comment.like_count }}
                </button>

                <button
                  class="icon-button"
                  (click)="_onSubReplyComment(comment.id)"
                  [class.is-hidden]="_singleMode"
                  [disabled]="memo.is_blinded"
                >
                  답글달기
                </button>
              </viewer-memo-actions>
            </div>
          </ng-container>

          <!-- 답글 수정 인풋 -->
          <ng-container *ngIf="comment.isSubReplyChangeOpened">
            <div class="reply-comment-top">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="12"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                  fill="#999999"
                />
              </svg>

              <viewer-memo-author
                [avatarImageURL]="_currentUser?.avatar_image_url"
                [name]="_currentUser?.nickname ?? ''"
                [badgeInfo]="memo.author?.badges?.[0]"
              >
              </viewer-memo-author>
            </div>
            <div class="reply-comment-input">
              <div
                class="nickname-indent"
                #nicknameElement
                *ngIf="!memo?.is_mine"
                (click)="
                  _onCommentAuthorClick({
                    bid: _bid,
                    id: memo.author.id,
                    avatar_image_url: memo.author.avatar_image_url,
                    nickname: memo.author.nickname
                  })
                "
              >
                &commat;{{ memo.author.nickname }}
              </div>
              <textarea
                rows="1"
                [attr.data-comment-id]="comment.id"
                [style.text-indent]="getNicknameIndent()"
                [value]="comment.content"
                (input)="_onSubReplyInputChange(comment.id, $event)"
                (scroll)="_onTextareaScroll($event)"
                (keydown.arrowup)="_onTextareaArrowKey($event)"
                (keydown.arrowdown)="_onTextareaArrowKey($event)"
                (keydown.arrowleft)="_onTextareaArrowKey($event)"
                (keydown.arrowright)="_onTextareaArrowKey($event)"
                (keydown)="
                  _onEditReplyTextareaKeyDown(
                    $event,
                    comment,
                    !!comment.is_mine,
                    comment.author.id
                  )
                "
              >
              </textarea>
            </div>
            <div class="reply-comment-input-bottom">
              <span (click)="_onCloseReplyChangeButtonClick(comment)"
                >취소</span
              >
              <span
                [class.is-active]="isReplyEditSaveEnabled(comment)"
                (click)="
                  _onEditReplyCommentInput(
                    comment,
                    !!memo.is_mine,
                    memo.author.id
                  )
                "
                >저장</span
              >
            </div>
          </ng-container>

          <!-- 답글의 답글 인풋 박스 -->
          <div
            class="reply-comment-item sub-reply-comment-input-item"
            *ngIf="comment.isSubReplyOpened === 1"
          >
            <div class="reply-comment-top">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="12"
                viewBox="0 0 9 7"
                fill="none"
              >
                <path
                  d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                  fill="#999999"
                />
              </svg>

              <viewer-memo-author
                [avatarImageURL]="_currentUser?.avatar_image_url"
                [name]="_currentUser?.nickname ?? ''"
                [badgeInfo]="memo.author?.badges?.[0]"
              >
              </viewer-memo-author>
            </div>
            <div class="reply-comment-input">
              <div
                class="nickname-indent"
                #nicknameElement
                *ngIf="!comment?.is_mine"
                (click)="_onCommentAuthorClick(comment.author)"
              >
                &commat;{{ comment?.author?.nickname }}
              </div>
              <textarea
                rows="1"
                [attr.data-comment-id]="comment.id"
                [style.text-indent]="getNicknameIndent()"
                [value]="_subReplyCommentInputValues[comment.id] || ''"
                (input)="_onSubReplyInputChange(comment.id, $event)"
                (scroll)="_onTextareaScroll($event)"
                (keydown.arrowup)="_onTextareaArrowKey($event)"
                (keydown.arrowdown)="_onTextareaArrowKey($event)"
                (keydown.arrowleft)="_onTextareaArrowKey($event)"
                (keydown.arrowright)="_onTextareaArrowKey($event)"
                (keydown)="
                  _onSubReplyTextareaKeyDown(
                    $event,
                    comment.id,
                    !!comment.is_mine,
                    comment.author.id
                  )
                "
              >
              </textarea>
            </div>
            <div class="reply-comment-input-bottom">
              <span (click)="_onCloseSubReplyComment(comment.id)">취소</span>
              <span
                [class.is-active]="
                  _subReplyCommentInputValues[comment.id] !== ''
                "
                (click)="
                  _onSaveSubReplyCommentInput(
                    comment.id,
                    comment.is_mine,
                    comment.author.id
                  )
                "
                >저장</span
              >
            </div>
          </div>

          <!-- 답글의 답글 목록 -->
          <div
            class="reply-comment-item sub-reply-comment-input-item"
            *ngFor="let reply of comment.replies"
          >
            <ng-container *ngIf="!reply.isSubReplyChangeOpened">
              <div class="reply-comment-top">
                <svg
                  class="reply-comment-top-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="12"
                  viewBox="0 0 9 7"
                  fill="none"
                >
                  <path
                    d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                    fill="#999999"
                  />
                </svg>

                <viewer-memo-author
                  [avatarImageURL]="reply.author.avatar_image_url"
                  [name]="reply.author.nickname"
                  (authorClick)="
                    !reply.is_mine && _onCommentAuthorClick(reply.author)
                  "
                  [class.is-clickable]="!reply.is_mine"
                  [badgeInfo]="reply.author?.badges?.[0]"
                >
                </viewer-memo-author>

                <div class="date" *ngIf="!reply.updated_at">
                  {{ reply.created_at | date : 'y.MM.dd. HH:mm' }}
                </div>
                <div class="date" *ngIf="reply.updated_at">
                  {{ reply.updated_at | date : 'y.MM.dd. HH:mm' }} (수정됨)
                </div>

                <sui-icon
                  class="reply-comment-more-button"
                  name="더보기 세로형"
                  [cdkMenuTriggerFor]="
                    reply.is_mine ? subReplyMyMenu : subReplyOthersMenu
                  "
                  [cdkMenuTriggerData]="{ subReply: reply, comment: comment }"
                  (click)="
                    $event.stopPropagation(); _onCommentMenuOpen(comment)
                  "
                ></sui-icon>
              </div>
              <div class="reply-comment-content">
                <span
                  *ngIf="reply.mention"
                  class="mention-highlight"
                  (click)="_onCommentAuthorClick(reply.mention)"
                >
                  &commat;{{ reply.mention.nickname }}
                </span>
                <span
                  [innerHTML]="
                    (getSubReplyShortContent(reply.id, reply.content)
                      ? getSubReplyShortContent(reply.id, reply.content) + '...'
                      : reply.content
                    )
                      | escapeHtml
                      | detectLink
                  "
                ></span>
              </div>
              <span
                class="show-all-content-button"
                *ngIf="getSubReplyShortContent(reply.id, reply.content)"
                (click)="onSubReplyShowAll(reply.id)"
                >자세히 보기</span
              >
              <span
                class="show-all-content-button"
                *ngIf="
                  !getSubReplyShortContent(reply.id, reply.content) &&
                  (reply.content.length > 64 ||
                    reply.content.split('\n').length > 3)
                "
                (click)="onSubReplyShowLess(reply.id, reply.content)"
                >간략히</span
              >
              <div class="reply-comment-bottom">
                <viewer-memo-actions>
                  <button
                    class="icon-button"
                    (click)="_onLikeSubReplyButtonClick(comment.id, reply.id)"
                  >
                    <sui-icon
                      name="추천"
                      [type]="reply.is_liked ? 'solid' : 'outline'"
                    ></sui-icon>
                    {{ reply.like_count }}
                  </button>

                  <button
                    class="icon-button"
                    (click)="_onSubSubReplyComment(comment.id, reply.id)"
                    [class.is-hidden]="_singleMode"
                    [disabled]="memo.is_blinded"
                  >
                    답글달기
                  </button>
                </viewer-memo-actions>
              </div>
            </ng-container>

            <!-- 답글의 답글 수정 인풋 박스 -->
            <ng-container *ngIf="reply.isSubReplyChangeOpened">
              <div class="reply-comment-top">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="12"
                  viewBox="0 0 9 7"
                  fill="none"
                >
                  <path
                    d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                    fill="#999999"
                  />
                </svg>

                <viewer-memo-author
                  [avatarImageURL]="_currentUser?.avatar_image_url"
                  [name]="_currentUser?.nickname ?? ''"
                  [badgeInfo]="memo.author?.badges?.[0]"
                >
                </viewer-memo-author>
              </div>
              <div class="reply-comment-input">
                <div
                  class="nickname-indent"
                  #nicknameElement
                  *ngIf="!comment?.is_mine"
                  (click)="_onCommentAuthorClick(comment.author)"
                >
                  &commat;{{ comment?.author?.nickname }}
                </div>
                <textarea
                  rows="1"
                  [attr.data-comment-id]="reply.id"
                  [style.text-indent]="getNicknameIndent()"
                  [value]="reply.content"
                  (input)="_onSubReplyInputChange(reply.id, $event)"
                  (scroll)="_onTextareaScroll($event)"
                  (keydown.arrowup)="_onTextareaArrowKey($event)"
                  (keydown.arrowdown)="_onTextareaArrowKey($event)"
                  (keydown.arrowleft)="_onTextareaArrowKey($event)"
                  (keydown.arrowright)="_onTextareaArrowKey($event)"
                  (keydown)="
                    _onEditReplyTextareaKeyDown(
                      $event,
                      reply,
                      !!reply.is_mine,
                      reply.author.id
                    )
                  "
                >
                </textarea>
              </div>
              <div class="reply-comment-input-bottom">
                <span (click)="_onCloseReplyChangeButtonClick(reply)"
                  >취소</span
                >
                <span
                  [class.is-active]="isReplyEditSaveEnabled(reply)"
                  (click)="
                    _onEditReplyCommentInput(
                      reply,
                      !!reply.is_mine,
                      reply.author.id
                    )
                  "
                  >저장</span
                >
              </div>
            </ng-container>

            <!-- 답글의 답글의 답글 인풋 박스 -->
            <div
              class="reply-comment-item sub-reply-comment-input-item"
              *ngIf="reply.isSubReplyOpened === 1"
            >
              <div class="reply-comment-top">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="12"
                  viewBox="0 0 9 7"
                  fill="none"
                >
                  <path
                    d="M8.4834 4.64844V6.26074H0.802734V0.0654297H2.85938V4.64844H8.4834Z"
                    fill="#999999"
                  />
                </svg>

                <viewer-memo-author
                  [avatarImageURL]="_currentUser?.avatar_image_url"
                  [name]="_currentUser?.nickname ?? ''"
                  [badgeInfo]="memo.author?.badges?.[0]"
                >
                </viewer-memo-author>
              </div>
              <div class="reply-comment-input">
                <div
                  class="nickname-indent"
                  #nicknameElement
                  *ngIf="!reply?.is_mine"
                  (click)="_onCommentAuthorClick(reply.author)"
                >
                  &commat;{{ reply?.author?.nickname }}
                </div>
                <textarea
                  rows="1"
                  [attr.data-comment-id]="reply.id"
                  [style.text-indent]="getNicknameIndent()"
                  [value]="_subSubReplyCommentInputValues[reply.id] || ''"
                  (input)="_onSubSubReplyInputChange(reply.id, $event)"
                  (scroll)="_onTextareaScroll($event)"
                  (keydown.arrowup)="_onTextareaArrowKey($event)"
                  (keydown.arrowdown)="_onTextareaArrowKey($event)"
                  (keydown.arrowleft)="_onTextareaArrowKey($event)"
                  (keydown.arrowright)="_onTextareaArrowKey($event)"
                  (keydown)="
                    _onSubSubReplyTextareaKeyDown(
                      $event,
                      comment.id,
                      reply.id,
                      !!reply.is_mine,
                      reply.author.id
                    )
                  "
                >
                </textarea>
              </div>
              <div class="reply-comment-input-bottom">
                <span (click)="_onCloseSubSubReplyComment(comment.id, reply.id)"
                  >취소</span
                >
                <span
                  [class.is-active]="
                    _subSubReplyCommentInputValues[reply.id] !== ''
                  "
                  (click)="
                    _onSaveSubSubReplyCommentInput(
                      comment.id,
                      reply.id,
                      reply.is_mine,
                      reply.author.id
                    )
                  "
                  >저장</span
                >
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </viewer-memo-reply-comment>
</viewer-memo>

<ng-template #myMenu let-menu="menu">
  <sui-menu class="viewer-memo-menu" cdkMenu>
    <button
      sui-menu-item
      cdkMenuItem
      *ngIf="!memo.is_blinded && !memo.copied_at"
      (click)="_onEditMenuClick()"
    >
      수정하기
    </button>
    <button sui-menu-item cdkMenuItem (click)="_onDeleteMenuClick()">
      삭제하기
    </button>
    <button sui-menu-item cdkMenuItem (click)="_onShareButtonClick(memo.id)">
      공유하기
    </button>
  </sui-menu>
</ng-template>

<ng-template #othersMenu let-menu="menu">
  <sui-menu cdkMenu>
    <button sui-menu-item cdkMenuItem (click)="_onShareButtonClick(memo.id)">
      공유하기
    </button>
    <button sui-menu-item cdkMenuItem (click)="_onReportMenuClick()">
      신고하기
    </button>
  </sui-menu>
</ng-template>

<!-- 답글 메뉴 템플릿 추가 -->
<ng-template #replyMyMenu let-reply="reply">
  <sui-menu class="viewer-reply-menu" cdkMenu>
    <button sui-menu-item cdkMenuItem (click)="_onEditReplyButtonClick(reply)">
      수정하기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onDeleteReplyButtonClick(reply)"
    >
      삭제하기
    </button>
  </sui-menu>
</ng-template>

<ng-template #replyOthersMenu let-reply="reply" let-comment="comment">
  <sui-menu class="viewer-reply-menu" cdkMenu>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onReportCommentMenuClick(reply)"
    >
      신고하기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onBlockReplyMenuClick(reply, false)"
    >
      답글 안보기
    </button>
  </sui-menu>
</ng-template>

<!-- 답글의 답글 메뉴 템플릿 추가 -->
<ng-template #subReplyMyMenu let-subReply="subReply" let-comment="comment">
  <sui-menu class="viewer-reply-menu" cdkMenu>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onEditReplyButtonClick(subReply)"
    >
      수정하기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onDeleteSubReplyButtonClick(subReply, comment)"
    >
      삭제하기
    </button>
  </sui-menu>
</ng-template>

<ng-template #subReplyOthersMenu let-subReply="subReply" let-comment="comment">
  <sui-menu class="viewer-reply-menu" cdkMenu>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onReportCommentMenuClick(subReply)"
    >
      신고하기
    </button>
    <button
      sui-menu-item
      cdkMenuItem
      (click)="_onBlockReplyMenuClick(subReply, true)"
    >
      답글 안보기
    </button>
  </sui-menu>
</ng-template>
